import {z} from '@hono/zod-openapi';

import {priceReportPurchasePriceSourceReasonSchema} from './priceReportPurchasePriceSourceReasonSchema';
import {priceReportPurchasePriceSourceSchema} from './priceReportPurchasePriceSourceSchema';

/**
 * One entry of a stored report's `markets`. Only the purchase price source and its reason are
 * declared; the legacy keys and `purchasePriceExchangeRate` (T20-142158) pass through as stored,
 * like every other part of the payload. Reports stored before T20-141867 carry neither declared
 * key.
 */
export const priceReportMarketSchema = z
  .object({
    purchasePriceSource: priceReportPurchasePriceSourceSchema.optional(),
    purchasePriceSourceReason: priceReportPurchasePriceSourceReasonSchema.optional(),
  })
  .passthrough()
  .openapi('PriceReportMarket');
